const state = {
    // Список всех баз пользователя
    bases: [],

    // Отображение модального окна удаления базы
    deleteBaseModal: false,

    // Отображение модального окна активации ключа
    activateLicenseModal: false,

    // Параметры текущей базы, над которой производятся действия
    currentBase: {}
};

const getters = {
    // Получение списка баз, в которых пользователь владелец
    getMyBaseList: state => state.bases.filter(base => base.isOwned),
    // Получение списка баз, на которые есть админ права
    getAdminBaseList: state => state.bases.filter(base => !base.isOwned && base.permissions.manage),
    // Получение списка баз, на которых нет админ прав
    getMemberBaseList: state => state.bases.filter(base => !base.isOwned && !base.permissions.manage)
};

const actions = {
    /**
     * Вызов мутации добавления кастомных данных в state
     *
     * @param stateData {object} - объект кастомных данных, в формате:
     *  {
     *      key1: value1,
     *      key2: value2
     *  }
     *
     * @returns void
     */
    addStateData: ({commit}, stateData) => commit('addStateData', stateData),

    /**
     * Вызов мутации сохранения в хранилище списка баз пользователя
     *
     * @param baseList {array} - массив баз пользователя
     *
     * @returns void
     */
    setBaseList: ({commit}, baseList) => commit('setBaseList', baseList),

    /**
     *  Вызов мутаций для установки значения state, отвечающего за отображение
     *      модального окна удаления базы из списка
     *
     * @param base {object} - база из компонента
     * @returns {*}
     */
    showDeleteBaseModal: ({ commit }, base) => {
        /*
         * actions - это родитель этого элемента, поэтому его не переопредлить.
         */
        let baseStatusEndPoint = legacyImportStatusUrl.replace('base_hash', base.hash_id);
        // локально let baseUrl = baseUrl.replace(... тоже не переопределяется
        let baseUrlLocal = baseUrl.replace('base_hash', base.hash_id);
        // Проверяем статус процесса
        axios.get(baseStatusEndPoint)
            .then(response => {
                if (response.data) {
                    // Если идет процесс импорта, то отправляем на base.show
                    location = baseUrlLocal;
                } else {
                    // Если процесс импорта не идет, то показываем окно удаления базы
                    commit('showDeleteBaseModal', base);
                };
            })
            .catch(error => {
                AppUtils.showServiceError(error);
            });
    },
    hideDeleteBaseModal: ({ commit }) => commit('hideDeleteBaseModal'),

    /**
     *  Вызов мутаций для установки значения state, отвечающего за отображение
     *      модального окна активации ключа
     *
     * @param base {object} - база из компонента
     * @returns {*}
     */
    showActivateLicenseModal: ({ commit }, base) => {
        commit('showActivateLicenseModal', base);
    },
    hideActivateLicenseModal: ({ commit }) => commit('hideActivateLicenseModal'),
};

const mutations = {
    // TODO: Убрать, когда будут реализованы отдельные мутации для локализации и actions
    addStateData: (state, stateData) => {
        Object.assign(state, stateData);
    },
    setBaseList: (state, baseList) => {
        Vue.set(state, 'bases', [...baseList]);
    },
    showDeleteBaseModal: (state, base) => {
        state.currentBase = base;
        state.deleteBaseModal = true;
    },
    hideDeleteBaseModal: state => {
        state.currentBase = {};
        state.deleteBaseModal = false;
    },

    showActivateLicenseModal: (state, base) => {
        state.currentBase = base;
        state.activateLicenseModal = true;
    },
    hideActivateLicenseModal: state => {
        state.currentBase = {};
        state.activateLicenseModal = false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
